module.exports = __webpack_public_path__ + "img/q_box_border.51bcbd4c.png";